function zeroIze() {
  const str = this.toString();
  return str.length === 1 ? "0" + str : str;
}

Number.prototype.$zeroIze = zeroIze;
